module.exports = __webpack_public_path__ + "static/media/join-in-img3-5.9409cdc2.png";